/* ═══════════════════════════════════════════════════
   NEWJAISA — SOLUTIONS PAGE
   File: assets/component-solutions.js
   Namespaced under SolPage · No global conflicts
   No jQuery · DOMContentLoaded · Zero inline onclick
═══════════════════════════════════════════════════ */

'use strict';

var SolPage = (function () {

  /* ── PRIVATE HELPERS ──────────────────────────── */
  function $(id)   { return document.getElementById(id); }
  function $$(sel) { return Array.from(document.querySelectorAll(sel)); }

  /* ── SMOOTH SCROLL TO SECTION ─────────────────── */
  function scrollToSection(id) {
    var el = $(id);
    if (!el) return;
    var snavHeight = 44;
    var extra      = 12;
    var top = el.getBoundingClientRect().top + window.pageYOffset - snavHeight - extra;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  /* ── STICKY NAV HIGHLIGHT ─────────────────────── */
  function initStickyNav() {
    var sections = [
      { id: 'sol-sec-sell',    btnId: 'sol-nav-sell'    },
      { id: 'sol-sec-buy',     btnId: 'sol-nav-buy'     },
      { id: 'sol-sec-raas',    btnId: 'sol-nav-raas'    },
      { id: 'sol-sec-amc', btnId: 'sol-nav-amc' },
      { id: 'sol-sec-csr', btnId: 'sol-nav-csr' },
      { id: 'sol-sec-process', btnId: 'sol-nav-process' },
      { id: 'sol-sec-faq',     btnId: 'sol-nav-faq'     }
    ];

    if (!('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var match = null;
        for (var i = 0; i < sections.length; i++) {
          if (sections[i].id === entry.target.id) { match = sections[i]; break; }
        }
        if (match) setNavActive(match.btnId);
      });
    }, { rootMargin: '-44px 0px -55% 0px' });

    sections.forEach(function (s) {
      var el = $(s.id);
      if (el) io.observe(el);
    });
  }

  function setNavActive(btnId) {
    $$('.sol-snav-btn').forEach(function (b) { b.classList.remove('active'); });
    var btn = $(btnId);
    if (btn) {
      btn.classList.add('active');
      /* Scroll active button into view on mobile */
      if (btn.scrollIntoView) {
        btn.scrollIntoView({ inline: 'center', behavior: 'smooth', block: 'nearest' });
      }
    }
  }

  /* ── SCROLL REVEAL ────────────────────────────── */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      $$('.sol-reveal').forEach(function (el) { el.classList.add('sol-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var parent = entry.target.parentElement;
        var siblings = parent
          ? Array.from(parent.children).filter(function (el) {
              return el.classList.contains('sol-reveal') && !el.classList.contains('sol-visible');
            })
          : [];
        var idx = siblings.indexOf(entry.target);

        setTimeout(function () {
          entry.target.classList.add('sol-visible');
        }, Math.max(0, idx * 80));

        io.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

    $$('.sol-reveal').forEach(function (el) { io.observe(el); });
  }

  /* ── FAQ ACCORDION ────────────────────────────── */
  function initFAQ() {
    $$('.sol-faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item   = btn.closest('.sol-faq-item');
        if (!item) return;
        var isOpen = item.classList.contains('open');

        /* Close all */
        $$('.sol-faq-item.open').forEach(function (i) {
          i.classList.remove('open');
          var q = i.querySelector('.sol-faq-q');
          if (q) q.setAttribute('aria-expanded', 'false');
        });

        /* Open clicked (if it was closed) */
        if (!isOpen) {
          item.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ── HERO CARDS → SCROLL ──────────────────────── */
  function initHeroCards() {
    $$('[data-scroll-to]').forEach(function (el) {
      el.addEventListener('click', function () {
        var target = el.getAttribute('data-scroll-to');
        if (target) scrollToSection(target);
      });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var target = el.getAttribute('data-scroll-to');
          if (target) scrollToSection(target);
        }
      });
    });
  }

  /* ── VIDEO BUTTON ─────────────────────────────── */
  function initVideoButtons() {
    function handleVideo() {
      alert('Facility video coming soon. Contact us at business@newjaisa.com for a live tour.');
    }

    var videoCard = $('sol-video-card');
    var videoBtn  = $('sol-video-btn');
    if (videoCard) {
      videoCard.addEventListener('click', handleVideo);
      videoCard.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleVideo(); }
      });
    }
    if (videoBtn) videoBtn.addEventListener('click', handleVideo);
  }

  /* ── YOUTUBE AUTOPLAY ON SECTION ENTER ────────── */
  function initVideoAutoplay() {
    var section = document.getElementById('sol-sec-raas');
    var iframe  = document.getElementById('sol-yt-iframe');
    var overlay = document.getElementById('sol-play-overlay');
    if (!section || !iframe) return;
    if (!('IntersectionObserver' in window)) return;

    var played = false;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !played) {
          played = true;
          iframe.src = iframe.getAttribute('data-src');
          iframe.addEventListener('load', function () {
            if (overlay) overlay.style.display = 'none';
          });
          io.disconnect();
        }
      });
    }, { threshold: 0.4 });

    io.observe(section);
  }

  /* ── INIT ─────────────────────────────────────── */
  function init() {
    initHeroCards();
    initStickyNav();
    initReveal();
    initFAQ();
    initVideoButtons();
    initVideoAutoplay();
  }

  return { init: init };

})();   // ← IIFE closes here

document.addEventListener('DOMContentLoaded', function () {
  SolPage.init();
});

/* ── YOUTUBE AUTOPLAY ON SECTION ENTER ────────── */
 function initVideoAutoplay() {
    var section = document.getElementById('sol-sec-raas');
    var iframe  = document.getElementById('sol-yt-iframe');
    var overlay = document.getElementById('sol-play-overlay');
    if (!section || !iframe) return;
    if (!('IntersectionObserver' in window)) return;

    var played = false;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !played) {
          played = true;
          iframe.src = iframe.getAttribute('data-src');
          iframe.addEventListener('load', function () {
            if (overlay) overlay.style.display = 'none';
          });
          io.disconnect();
        }
      });
    }, { threshold: 0.4 });

    io.observe(section);
  }

// Ghraph for Solutions Page
(function () {
  var tt = document.getElementById('njLcTooltip');

  document.querySelectorAll('.nj-lc-seg-list li[data-href]').forEach(function (li) {
    li.addEventListener('click', function () {
      window.location.href = li.getAttribute('data-href');
    });
  });

  var segLabels = {
    '#sol-sec-sell': 'Requirement Analysis',
    '/pages/about-newjaisa?view=b2b-enterprise-quote': 'Procurement',
    '/pages/about-newjaisa?view=b2b-pricing': 'Financing',
    '/pages/about-newjaisa?view=b2b-pricing#prc-tab-included': 'Deployment & Maintenance',
    '/pages/about-newjaisa?view=b2b-pricing#prc-tab-warranty': 'Warranty Management',
    '#sol-sec-buy': 'Asset Liquidation & Disposal'
  };

  document.querySelectorAll('.nj-seg-path').forEach(function (path) {
    var href = path.getAttribute('data-href');

    path.addEventListener('click', function () {
      window.location.href = href;
    });

    path.addEventListener('mouseenter', function (e) {
      if (!tt) return;
      tt.textContent = segLabels[href] || '';
      tt.classList.add('nj-lc-tt-show');
    });

    path.addEventListener('mousemove', function (e) {
      if (!tt) return;
      tt.style.left = (e.clientX + 12) + 'px';
      tt.style.top  = (e.clientY - 28) + 'px';
    });

    path.addEventListener('mouseleave', function () {
      if (!tt) return;
      tt.classList.remove('nj-lc-tt-show');
    });
  });

  /* ── Segment title hover highlight matching wheel segment ── */
  document.querySelectorAll('.nj-lc-seg').forEach(function (seg) {
    var key = seg.getAttribute('data-seg');
    var map = {
      analysis:    '#sol-sec-sell',
      procurement: '/pages/about-newjaisa?view=b2b-enterprise-quote',
      financing:   '/pages/about-newjaisa?view=b2b-pricing',
      deployment:  '/pages/about-newjaisa?view=b2b-pricing#prc-tab-included',
      warranty:    '/pages/about-newjaisa?view=b2b-pricing#prc-tab-warranty',
      liquidation: '#sol-sec-buy'
    };
    var href = map[key];
    if (!href) return;

    var svgPath = document.querySelector('.nj-seg-path[data-href="' + href + '"]');
    if (!svgPath) return;

    seg.addEventListener('mouseenter', function () {
      svgPath.style.opacity = '0.8';
      svgPath.style.filter = 'brightness(1.1)';
    });
    seg.addEventListener('mouseleave', function () {
      svgPath.style.opacity = '';
      svgPath.style.filter = '';
    });
  });
})();

//Automatic open to tha redirect to the navtap pages 2nd April 2026
// document.addEventListener("DOMContentLoaded", function () {
//   const params = new URLSearchParams(window.location.search);
//   const tab = params.get("tab");

//   if (tab && typeof coOpenTab === "function") {
//     coOpenTab(tab);
//   } else {
//     coHandleHash(); // fallback
//   }
// });
